<ng-container *ngIf="isTransmission">
  <span
    class="transmission-badge"
    matTooltip="Transmission"
    matTooltipPosition="above"
  >
    T
  </span>
</ng-container>
